import { APIs } from 'src/models/apis';
import { useQuery } from 'react-query';
import { useAPIs } from 'src/hooks/useAPIs';
import { QueryKey } from 'src/models/query';
import { ProductSearchParams } from 'src/models/pim';

export const fetchProductsListQuery = (
  apis: APIs,
  params?: ProductSearchParams,
) => ({
  queryKey: [...QueryKey.Products, params],
  queryFn: () => apis.pim.products.list(params),
});

export const useProductsListQuery = (params?: ProductSearchParams) => {
  const apis = useAPIs();

  return useQuery(fetchProductsListQuery(apis, params));
};
